import { isBarbsDirectionParameter, isBarbsSpeedParameter } from "@/constants/barbsParameters";
import type { WeatherParamFormat } from "@mm/weather-parameter-utils";

/**
 * For wind and ocean speed barbs, only "kn" is available. Direction-only wave
 * barbs use degrees.
 */
export function onlySupportedBarbsParamFormat(layerFormat: WeatherParamFormat) {
  if (isBarbsSpeedParameter(layerFormat.format)) {
    if (!layerFormat.unit.includes("kn")) {
      // Format without "kn" option is disabled
      return null;
    }
    // Only "kn" option is available
    layerFormat.unit = ["kn"];
    return layerFormat;
  }

  if (isBarbsDirectionParameter(layerFormat.format)) {
    if (!layerFormat.unit.includes("d")) {
      return null;
    }
    layerFormat.unit = ["d"];
    return layerFormat;
  }

  if (!layerFormat.unit.includes("kn")) {
    return null;
  }
  layerFormat.unit = ["kn"];
  return layerFormat;
}
